import React, { useState } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom"
import { ToggleButton, ButtonGroup  } from 'react-bootstrap';
import JSONPretty from 'react-json-pretty';
import axios from "axios";

 
 
const Seleziona_la_classe = (props) => {
//    const [somma, calcola_somma] = useState('');

    function Scelta_programma2 (event) {


        console.log("ssssssssssssssssssssssssssssssssssss")

        /* idroslab il tutor sceglie su quale classe lavorare*/
     
        console.log(event.target.value)
        if (event.target.value !== undefined) {
            props.SET_classe_selezionata(event.target.value)
            axios.patch('/tutor/ultima_classe_selezionata/' + props.tutor._id + '/' + event.target.value)
            .then((res) => {
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
        }
    }



    return (
        <> 
              {/* <JSONPretty data={props.lista_classi} /> */}
  
			  <ButtonGroup onClick={Scelta_programma2}>
                    {props.lista_classi.map(function (item, idx) {
                        {
                            //                        console.log(item)
                            return <>
                                 <ToggleButton
                                    key={idx}
                                    id={`radio-${idx}`}
                                    type="radio"
                                    variant={idx % 2 ? 'outline-success' : 'outline-danger'}
                                    name="radio"
                                    value={item._id}
                                    checked={item._id === props.classe_selezionata}
                                    >
                                    {item.nome}
                                </ToggleButton>
                            </>
                        }
                    })
                    }
                </ButtonGroup>
        </>
    )
}
export default Seleziona_la_classe;